module.exports = __webpack_public_path__ + "img/card-frame-orange.9c1ab4da.png";